<template>
    <v-list dense class="kp-context-menu">
        <template v-if="record.status === Event.STATUS_DELETED">
            <v-list-item @click="onInput('status', Event.STATUS_DRAFT)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-clearcache ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('wiederherstellen') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <template v-else>
            <v-list-item v-if="!hidePreview" :href="getUrl(true)" target="tgk_preview">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-preview ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('preview') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                :to="{ name: 'event-info-categories', params: { id: record.id, backRoute: { route: $route } } }"
            >
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-pencil ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'event-express-edit', params: { id: record.id, backRoute: { route: $route } } }">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-pencil ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('edit_express') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="!hideDuplicate" @click="$emit('duplicate-record', record)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-copy ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('duplicate') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="$emit('delete-record', record)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-trash ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="!hidePreview" @click="copyUrl">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-link ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('copy_url') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="userIsStaff()" @click="onInput('is_featured', !record.is_featured)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-typed ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        record.is_featured ? $t('remove_featured') : $t('add_featured')
                    }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="userIsStaff()" @click="onInput('to_newsletter', !record.to_newsletter)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-tonewsletter ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        record.to_newsletter ? $t('remove_newsletter') : $t('add_newsletter')
                    }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="copyId(record.id)">
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-copy ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('copy_id') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-if="userIsStaff() && record.status !== EventStatus.REJECTED"
                @click="$emit('reject-record', record)"
            >
                <v-list-item-icon>
                    <v-icon>ic ic-20 ic-rejected ic-col-grey</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('reject') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { Event, EventStatus } from '@/models/Event';
import { copyTextToClipboard, errToStr } from '@/helpers/tools';
import { globalParam } from '@/helpers/globals';
import { userIsStaff } from '@/helpers/auth';

export default {
    name: 'EventContextMenu',

    props: {
        record: {
            type: Event,
            default: () => null,
        },
        hideDuplicate: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showRejectConfirmDlg: false,
        };
    },

    computed: {
        hidePreview() {
            return globalParam('event.hide_preview');
        },
    },

    created() {
        this.Event = Event;
        this.EventStatus = EventStatus;
    },

    methods: {
        userIsStaff,

        getUrl(preview = false) {
            if (preview) {
                return this.record?.detailPreviewUrl;
            }
            return this.record?.detailUrl;
        },

        async copyUrl() {
            try {
                await navigator.clipboard.writeText(this.getUrl());
            } catch (error) {
                this.$toast({ message: this.$t('could_not_copy_to_clipboard'), color: 'error' });
            }
        },

        async copyId(recordId) {
            copyTextToClipboard(String(recordId));
        },

        async onInput(field, value) {
            this.record.set(field, value);
            try {
                await this.record.save();
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
                this.record.reset();
            } finally {
                this.$emit('reload-list');
            }
        },
    },
};
</script>
